/**
 * @constant BsUtilEmptyMarket Constant for empty market
 */
export var BsUtilEmptyMarket = {
    eventId: "0",
    leagueId: "0",
    isLive: false
};
/**
 * @constant BsUtilEmptySelection Constant for empty selection
 */
export var BsUtilEmptySelection = {
    id: "0",
    marketId: "0",
    group: 0,
    name: "",
    title: "",
    betslipLine: "",
    participantMapping: "",
    displayOdds: {},
    trueOdds: 0,
    points: 0,
    isDisabled: false,
    tags: [],
    metadata: {
        idSBTech: "0",
        type: "0"
    },
    status: ""
};
//# sourceMappingURL=index.js.map